<app-base-pesquisa #modal titulo="Pesquisa de Modelos de História Clínica"
    subtitulo="Clique duas vezes em cima da linha do registro para realizar a seleção."
    (carregarDados)="recarregar()"
    (registroSelecionado)="selecionado($event)">
    <ng-template appFiltroPesquisa>
        <form novalidate="true" [formGroup]="modelo">
            <div class="filtro-container">
                <label class="filtro-titulo">
                    <i class="fal fa-filter"></i>Filtros
                </label>

                <div class="filtro-campos">
                    <div class="filtro-campo-auto">
                        <ejs-checkbox formControlName="meusModelos" label="Apenas meus modelos"></ejs-checkbox>
                    </div>

                    <div class="filtro-campo-auto">
                        <ejs-checkbox formControlName="ativo" label="Exibir apenas ativos"></ejs-checkbox>
                    </div>
                </div>

                <div class="filtro-acao">
                    <input type="button" (click)="pesquisar()" ejs-button iconCss="fas fa-search" value="Pesquisar"
                        cssClass="e-primary" />
                </div>
            </div>
        </form>
    </ng-template>
    <ng-template appConteudoPesquisa>
        <ejs-grid #grid appGridPesquisa [dataSource]="registros" [enableVirtualization]='true' height='100%'
            [filterSettings]='filterSettings' [searchSettings]='searchSettings' [allowFiltering]='true'
            [allowSorting]='true' [allowResizing]='true' [toolbar]='toolbarItens' [showColumnChooser]='true'
            [showColumnMenu]='true' [pageSettings]='{ pageSize: 100 }' [allowExcelExport]='true' [allowPdfExport]='true'
            (toolbarClick)='toobarClick($event);toolbar.handleExport($event, grid);'>
            <e-columns>
                <e-column field='id' width='80' [headerText]="'Id'" [isPrimaryKey]="true" [visible]="true"></e-column>
                <e-column field='titulo' [headerText]="'Título'" [visible]="true"></e-column>
                <e-column field='observacao' [headerText]="'Observação'" [visible]="true"></e-column>
                <e-column field='profissionalNome' [headerText]="'Profissional'"></e-column>
                <e-column field='ativo' [headerText]="'Ativo'" [type]="'boolean'" [displayAsCheckBox]="true"></e-column>
                <e-column field='criacaoDataHora' [headerText]="'Data Criação'" [type]="'date'"
                    [format]="{type: 'date', format: 'dd/MM/yyyy HH:mm'}"></e-column>
            </e-columns>

            <e-aggregates>
                <e-aggregate>
                    <e-columns>
                        <e-column field="id" type="count">
                            <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                        </e-column>
                    </e-columns>
                </e-aggregate>
            </e-aggregates>

        </ejs-grid>

    </ng-template>
</app-base-pesquisa>
